// assets
import {
  HomeOutlined,
  UsergroupAddOutlined,
  UserAddOutlined,
  SafetyCertificateOutlined,
  UserOutlined,
  EnvironmentOutlined,
  ChromeOutlined
} from '@ant-design/icons';

// icons
const icons = {
  HomeOutlined,
  UsergroupAddOutlined,
  UserAddOutlined,
  SafetyCertificateOutlined,
  UserOutlined,
  EnvironmentOutlined,
  ChromeOutlined
};

/**
 * Configuration for dashboard navigation items.
 *
 * This object defines a group of navigation items related to the dashboard functionality of an application.
 * Each item is defined with specific properties like id, title, type, url, and icon to facilitate dynamic rendering
 * of navigation elements. This structure is particularly useful for creating a side navigation menu in a web application.
 *
 * @type {Object} dashboard - The dashboard navigation configuration.
 * @property {string} id - A unique identifier for the group.
 * @property {string} type - The type of navigation element, in this case, a 'group'.
 * @property {Array} children - An array of navigation items within this group.
 * @property {string} children[].id - A unique identifier for each navigation item.
 * @property {string} children[].title - The title of the navigation item.
 * @property {string} children[].type - The type of the navigation item, typically 'item' for individual links.
 * @property {string} children[].url - The URL path that the navigation item links to.
 * @property {JSX.Element} children[].icon - The icon component to be displayed alongside the navigation item.
 * @property {boolean} children[].breadcrumbs - Indicates if breadcrumbs should be shown for this item.
 * @property {boolean} children[].target - Indicates if the link should open in a new tab.
 */
const dashboard = {
  id: 'group-dashboard',
  type: 'group',
  children: [
    {
      id: 'homepage1',
      title: 'Homepage',
      type: 'item',
      url: '/homepage_admin',
      icon: icons.HomeOutlined,
      breadcrumbs: false,
      target: false
    },
    {
      id: 'existing-users',
      title: 'Existing Users',
      type: 'item',
      url: '/existing_users',
      icon: icons.UsergroupAddOutlined,
      breadcrumbs: false,
      target: false
    },
    {
      id: 'new-users',
      title: 'New Users',
      type: 'item',
      url: '/new_users',
      icon: icons.UserAddOutlined,
      breadcrumbs: false,
      target: false
    },
    {
      id: 'compliance-management',
      title: 'Compliance Management',
      type: 'item',
      url: '/compliance_management',
      icon: icons.SafetyCertificateOutlined,
      breadcrumbs: false,
      target: false
    },
    {
      id: 'patient-engagement',
      title: 'Patient Engagement',
      type: 'item',
      url: '/patient_engagement',
      icon: icons.UserOutlined,
      breadcrumbs: false,
      target: false
    },
    {
      id: 'user-feedback',
      title: 'User Feedback',
      type: 'item',
      url: '/user_feedback',
      icon: icons.EnvironmentOutlined,
      breadcrumbs: false,
      target: false
    },
    {
      id: 'waitlist',
      title: 'Waitlist',
      type: 'item',
      url: '/user_waitlist',
      icon: icons.UserAddOutlined,
      breadcrumbs: false,
      target: false
    },
    {
      id: 'TimeTracking clinician Report',
      title: 'Time Tracking User Report',
      type: 'item',
      url: '/time_tracking_clinician_report',
      icon: icons.UserAddOutlined,
      breadcrumbs: false,
      target: false
    },
    {
      id: 'TimeTracking patient Report',
      title: 'Time Tracking Patient Report',
      type: 'item',
      url: '/time_tracking_patient_report',
      icon: icons.UserAddOutlined,
      breadcrumbs: false,
      target: false
    },
    {
      id: 'ActivityReport',
      title: 'Activity Report',
      type: 'item',
      url: '/activity_report',
      icon: icons.UserAddOutlined,
      breadcrumbs: false,
      target: false
    },
    {
      id: 'Video Watch Percentage Report',
      title: 'Video Watch Percentage Report',
      type: 'item',
      url: '/video_watch_Percentage_Report',
      icon: icons.UserAddOutlined,
      breadcrumbs: false,
      target: false
    },
    {
      id: 'user-logins',
      title: 'User Logins',
      type: 'item',
      url: '/user_Logins',
      icon: icons.UserAddOutlined,
      breadcrumbs: false,
      target: false
    },
    {
      id: 'user-list',
      title: 'User List',
      type: 'item',
      url: '/user_List',
      icon: icons.UserAddOutlined,
      breadcrumbs: false,
      target: false
    },
    {
      id: 'completed-consent-bundles',
      title: 'Completed Consent Bundles',
      type: 'item',
      url: '/completed-Consent-bundles',
      icon: icons.UserAddOutlined,
      breadcrumbs: false,
      target: false
    },
    {
      id: 'help&support',
      title: 'Help & Support',
      type: 'item',
      url: '/help&support',
      icon: icons.ChromeOutlined,
      breadcrumbs: false,
      target: false
    }
  ]
};

export default dashboard;
